import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, ViewChild, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootPrintPortalManager_ShellService } from './FootPrintPortalManager.shell.service';
import { FootPrintPortalManager_OperationService } from './FootPrintPortalManager.operation.service';
import { FootPrintPortalManager_DatasourceService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_FlowService } from './FootPrintPortalManager.flow.index';
import { FootPrintPortalManager_ReportService } from './FootPrintPortalManager.report.index';
import { FootPrintPortalManager_LocalizationService } from './FootPrintPortalManager.localization.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootPrintPortalManager.frontend.types'
import { $frontendTypes as $types} from './FootPrintPortalManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';



interface IFootPrintPortalManager_shipping_orders_by_tracking_gridComponentEntity {
Id?: number, CancelThresholdDate?: string, CreatedSysDateTime?: string, FulfillmentDate?: string, LookupCode?: string, Notes?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, PreferredCarrierId?: number, PreferredWarehouseId?: number, ProjectId?: number, RequestedDeliveryDate?: string, VendorReference?: string, Status?: { Id?: number, Name?: string }, OrderClass?: { LookupCode?: string }, Project?: { LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } }, Account?: { Id?: number }, PreferredWarehouse?: { Id?: number, Name?: string }, PreferredCarrier?: { Id?: number, Name?: string }, PreferredCarrierServiceType?: { Id?: number, Name?: string }, ShipmentOrderLookups?: { OrderId?: number, ShipmentId?: number, Shipment?: { ContainerSize?: string, ExpectedDate?: string, LookupCode?: string, ShippedDate?: string, StatusId?: number, TrackingIdentifier?: string, WaveId?: number, Wave?: { StatusId?: number, Status?: { Name?: string } } } }[], Addresses?: { AttentionOf?: string, Country?: string, FirstName?: string, LastName?: string, Line2?: string, PostalCode?: string, PrimaryEmail?: string, PrimaryTelephone?: string, State?: string }[], total_picked?: { TotalUnitsPicked?: number }, total_order_units?: { TotalUnits?: number, TotalPrice?: number, OrderId?: number }, calculated_total_items?: string}

interface IFootPrintPortalManager_shipping_orders_by_tracking_gridComponentInParams {
  ownerId: number, projectId?: number, warehouseId?: number[], statusIds?: number[], reference?: string, materialIds?: number[], fromDate?: string, toDate?: string, ship_to_search?: string}


class FootPrintPortalManager_shipping_orders_by_tracking_gridComponentRowModel extends GridRowModel {
  grid: FootPrintPortalManager_shipping_orders_by_tracking_gridComponent;
  entity: IFootPrintPortalManager_shipping_orders_by_tracking_gridComponentEntity;

  vars: { stateId?: number, dockAppointmentId?: number } = { };


 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    lookupcode: new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    vendor_reference: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    reference: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    status: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    tracking: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    carrier: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    shipped_date: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null,  'datetime', 'l, LT', null)
,
null
      ),
    total_items: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    ship_to: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    created_date: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null,  'datetime', 'l, LT', null)
,
null
      ),
    requested_delivery_date: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null,  'datetime', 'l, LT', null)
,
null
      ),
    warehouse: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
  }



  constructor(
    private utils: UtilsService,
private settings: SettingsValuesService,
private shell: FootPrintPortalManager_ShellService,
private datasources: FootPrintPortalManager_DatasourceService,
private flows: FootPrintPortalManager_FlowService,
private reports: FootPrintPortalManager_ReportService,
private localization: FootPrintPortalManager_LocalizationService,
private operations: FootPrintPortalManager_OperationService,
private logger: CleanupLoggerService,
) {
    super();
    
  }

  async $initializeExisting(grid: FootPrintPortalManager_shipping_orders_by_tracking_gridComponent, entity: IFootPrintPortalManager_shipping_orders_by_tracking_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(grid: FootPrintPortalManager_shipping_orders_by_tracking_gridComponent, entity?: IFootPrintPortalManager_shipping_orders_by_tracking_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      ownerId:  $grid.inParams.ownerId ,
      projectId:  $grid.inParams.projectId ,
      warehouseId:  $grid.inParams.warehouseId ,
      statusIds:  $grid.inParams.statusIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      fromDate:  $grid.inParams.fromDate ,
      toDate:  $grid.inParams.toDate ,
      reference:  $grid.inParams.reference ,
      take:  null ,
      skip:  null ,
      materialIds:  $grid.inParams.materialIds ,
      dateType:  'CreatedSysDateTime' ,
      ship_to_search:  $grid.inParams.ship_to_search ,
    };
    const data = await this.datasources.FootPrintPortalManager.ds_shipping_orders_grid.getByKeys(inParams);
    this.entity = data.result[0];
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    (this.cells.lookupcode.displayControl as TextModel).text = $row.entity.LookupCode;
    (this.cells.vendor_reference.displayControl as TextModel).text = $row.entity.VendorReference;
    (this.cells.reference.displayControl as TextModel).text = $row.entity.OwnerReference;
    (this.cells.status.displayControl as TextModel).text = $row.entity.Status?.Name;
    (this.cells.tracking.displayControl as TextModel).text = $row.entity.ShipmentOrderLookups[0]?.Shipment?.TrackingIdentifier;
    (this.cells.warehouse.displayControl as TextModel).text = $row.entity.PreferredWarehouse?.Name;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'lookupcode' : {
        this.on_lookupcode_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_lookupcode_clicked(event = null) {
    return this.on_lookupcode_clickedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lookupcode_clickedInternal(
    $row: FootPrintPortalManager_shipping_orders_by_tracking_gridComponentRowModel,
  $grid: FootPrintPortalManager_shipping_orders_by_tracking_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  
  
  // Check order class type
  const order = (await $datasources.SalesOrders.ds_get_order_by_orderId.get({ orderId: $row.entity.Id })).result;
  if ($utils.isDefined(order)) {
      const orderClassTypeId = order.OrderClass.OrderClassTypeId;
      if (orderClassTypeId == 5) {
          $shell.FootPrintPortalManager.openshipping_order_editor({ orderId: $row.entity.Id });
      }
      else {
          throw new Error('Editor for selected order class type under development!')
      }
  
  }
  
  
  
  
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootPrintPortalManager_shipping_orders_by_tracking_gridComponentRowModel,
  $grid: FootPrintPortalManager_shipping_orders_by_tracking_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  // Set Date/Time Formats
  const format = `${$settings.FootPrintPortalManager.DateFormat}, ${$settings.FootPrintPortalManager.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`;
  
  // Apply date format
  if ($utils.isDefined($row.entity.RequestedDeliveryDate)) {
  
      $row.cells.requested_delivery_date.displayControl.text = $utils.date.format($row.entity.RequestedDeliveryDate, format);
  };
  
  if ($utils.isDefined($row.entity.CreatedSysDateTime)) {
  
      $row.cells.created_date.displayControl.text = $utils.date.format($row.entity.CreatedSysDateTime, format);
  };
  
  if ($utils.isDefined($row.entity.ShipmentOrderLookups[0]?.Shipment?.ShippedDate)) {
      $row.cells.shipped_date.displayControl.text = $utils.date.format($row.entity.ShipmentOrderLookups[0]?.Shipment?.ShippedDate, format);
  };
  
  
  //Set Carrier cell display control text
  var carrier = $utils.isDefined($row.entity.PreferredCarrier?.Name) ? $row.entity.PreferredCarrier?.Name : '';
  var service = $utils.isDefined($row.entity.PreferredCarrierServiceType?.Name) ? $row.entity.PreferredCarrierServiceType?.Name : '';
  var carrierDetails = carrier + ' ' + service;
  $row.cells.carrier.displayControl.text = carrierDetails;
  
  
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootPrintPortalManager-shipping_orders_by_tracking_grid',
  templateUrl: './FootPrintPortalManager.shipping_orders_by_tracking_grid.component.html'
})
export class FootPrintPortalManager_shipping_orders_by_tracking_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootPrintPortalManager_shipping_orders_by_tracking_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootPrintPortalManager_shipping_orders_by_tracking_gridComponentInParams = { ownerId: null, projectId: null, warehouseId: [], statusIds: [], reference: null, materialIds: [], fromDate: null, toDate: null, ship_to_search: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'Order', false, false, null),       vendor_reference: new GridHeaderModel(new HeaderStyles(null, null), 'Vendor reference', false, false, null),       reference: new GridHeaderModel(new HeaderStyles(null, null), 'Owner reference', false, false, null),       status: new GridHeaderModel(new HeaderStyles(null, null), 'Status', false, false, null),       tracking: new GridHeaderModel(new HeaderStyles(null, null), 'Tracking', false, false, null),       carrier: new GridHeaderModel(new HeaderStyles(null, null), 'Carrier', false, false, null),       shipped_date: new GridHeaderModel(new HeaderStyles(null, null), 'Shipped date', false, false, null),       total_items: new GridHeaderModel(new HeaderStyles(null, null), 'Total items', false, false, null),       ship_to: new GridHeaderModel(new HeaderStyles(null, null), 'Ship to', false, false, null),       created_date: new GridHeaderModel(new HeaderStyles(null, null), 'Created', false, false, null),       requested_delivery_date: new GridHeaderModel(new HeaderStyles(null, null), 'Requested delivery', false, false, null),       warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'Warehouse', false, false, null),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootPrintPortalManager_shipping_orders_by_tracking_gridComponentRowModel[] = [];
  @ViewChild('$gridComponent', { read:  GridComponent}) $gridComponent: GridComponent;

  @Input('ownerId') set $inParams_ownerId(value: any) {
    this.inParams['ownerId'] = value;
  }
  get $inParams_ownerId(): any {
    return this.inParams['ownerId'] ;
  }
  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }
  @Input('warehouseId') set $inParams_warehouseId(value: any) {
    this.inParams['warehouseId'] = value;
  }
  get $inParams_warehouseId(): any {
    return this.inParams['warehouseId'] ;
  }
  @Input('statusIds') set $inParams_statusIds(value: any) {
    this.inParams['statusIds'] = value;
  }
  get $inParams_statusIds(): any {
    return this.inParams['statusIds'] ;
  }
  @Input('reference') set $inParams_reference(value: any) {
    this.inParams['reference'] = value;
  }
  get $inParams_reference(): any {
    return this.inParams['reference'] ;
  }
  @Input('materialIds') set $inParams_materialIds(value: any) {
    this.inParams['materialIds'] = value;
  }
  get $inParams_materialIds(): any {
    return this.inParams['materialIds'] ;
  }
  @Input('fromDate') set $inParams_fromDate(value: any) {
    this.inParams['fromDate'] = value;
  }
  get $inParams_fromDate(): any {
    return this.inParams['fromDate'] ;
  }
  @Input('toDate') set $inParams_toDate(value: any) {
    this.inParams['toDate'] = value;
  }
  get $inParams_toDate(): any {
    return this.inParams['toDate'] ;
  }
  @Input('ship_to_search') set $inParams_ship_to_search(value: any) {
    this.inParams['ship_to_search'] = value;
  }
  get $inParams_ship_to_search(): any {
    return this.inParams['ship_to_search'] ;
  }

  topToolbar = {
      refresh: new ToolModel(new ButtonModel('refresh', new ButtonStyles(null, null), false, false, 'Refresh', 'ms-Icon ms-Icon--Process', null)
    , false),
      separator1: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      print: new ToolModel(new ButtonModel('print', new ButtonStyles(null, null), false, false, ' ', 'ms-Icon ms-Icon--Print', null)
    , false)
  };

  bottomToolbar = {
  };



  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    private shell: FootPrintPortalManager_ShellService,
    private datasources: FootPrintPortalManager_DatasourceService,
    private flows: FootPrintPortalManager_FlowService,
    private reports: FootPrintPortalManager_ReportService,
    private localization: FootPrintPortalManager_LocalizationService,
    private operations: FootPrintPortalManager_OperationService,
    private logger: CleanupLoggerService,
    ) {
    super();
    this.title = 'Shipping orders by tracking number';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.ownerId)) {
        this.$missingRequiredInParams.push('ownerId');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.utils;

    this.pageSize = 100;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  $rowPropertyChangeCallback (source: GridRowModel, property: string): void {
    if (property === 'selected') {
      this.$gridComponent.updateAllSelected();
    }
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      ownerId:  $grid.inParams.ownerId ,
      projectId:  $grid.inParams.projectId ,
      warehouseId:  $grid.inParams.warehouseId ,
      statusIds:  $grid.inParams.statusIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      fromDate:  $grid.inParams.fromDate ,
      toDate:  $grid.inParams.toDate ,
      reference:  $grid.inParams.reference ,
      take:  null ,
      skip:  null ,
      materialIds:  $grid.inParams.materialIds ,
      dateType:  'CreatedSysDateTime' ,
      ship_to_search:  $grid.inParams.ship_to_search ,
    };
    try {
    const data = await this.datasources.FootPrintPortalManager.ds_shipping_orders_grid.getList(inParams);
      this.entities = data.result;
      this.totalCount = data.totalCount;
      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootPrintPortalManager_shipping_orders_by_tracking_gridComponentRowModel(
          this.utils,
          this.settings,
          this.shell, 
          this.datasources,
          this.flows,
          this.reports,
          this.localization,
          this.operations,
          this.logger);
        rowLoadPromises.push( row.$initializeExisting(this, entity, this.$rowPropertyChangeCallback.bind(this)));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_grid_data_loaded();
  }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: FootPrintPortalManager_shipping_orders_by_tracking_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  //Initialize all buttons to read only true
  
  
  $grid.topToolbar.print.control.readOnly = true;
  
  $event;
  
  const selectedRowsCount = $grid.selectedRows.length;
  
  // One or more rows selected
  if (selectedRowsCount > 0) {
      const selectedRows = $grid.selectedRows;
  
  
      setButtonsByOrderStatusNames($grid.selectedRows.filter(row => $utils.isDefined(row.vars.stateId)).map(row => row.vars.stateId));
  
  
      if (await $operations.FootPrintPortalManager.Disable_ShippingOrder_Print.isAuthorized()) {
          $grid.topToolbar.print.control.readOnly = true;
      }
      else {
          $grid.topToolbar.print.control.readOnly = false;
      }
  }
  
  
  
  
  else {
  
  
  }
  
  
  
  /****************************************
   * FUNCTIONS
  *****************************************/
  
  async function checkAttachments() {
      let allow = $grid.selectedRows.length > 0;
  
      for (let row of $grid.selectedRows) {
          if ($utils.isDefined(row.entity.ShipmentOrderLookups)) {
  
              if (await $operations.FootPrintPortalManager.Disable_ShippingOrder_Attachments.isAuthorized()) {
                  return false;
              }
  
          }
          else {
              return false;
          }
      }
  
      return allow;
  }
  
  
  function setButtonsByOrderStatusNames(statusNames: number[]) {
  
      // TODO: Handle Manual Allocation related statuses
      if (statusNames.indexOf(1) > -1) {
  
  
      }
      if (statusNames.indexOf(2) > -1 || statusNames.indexOf(3) > -1 || statusNames.indexOf(4) > -1) {
  
      }
      if (statusNames.indexOf(5) > -1 || statusNames.indexOf(6) > -1) {
  
   
      }
      if (statusNames.indexOf(7) > -1) {
  
      }
      if (statusNames.indexOf(8) > -1) {
  
      }
      if (statusNames.indexOf(9) > -1) {
       
      }
  }
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootPrintPortalManager_shipping_orders_by_tracking_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  }
  on_export_flow(event = null) {
    return this.on_export_flowInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_export_flowInternal(
    $grid: FootPrintPortalManager_shipping_orders_by_tracking_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  const exportLimit = $settings.FootPrintPortalManager.ExcelExportLimit
  
  
  //Initialize
  var wb = $event;
  var transactions = [];
  var totalRecords: number;
  
  var exportType: string = "Summary";
  
  
  let dateFormat = $settings.FootPrintPortalManager.DateFormat ?? "MM/dd/yyyy";
  
  // Get Selected Rows only. 
  if ($grid.selectedRows.length > 0) {
      var orderIds = [...new Set($grid.selectedRows.map(o => o.entity.Id))]
      totalRecords = $grid.selectedRows.length;
  }
  
  let inParams = {
      ownerId: $grid.inParams.ownerId,
      projectId: $grid.inParams.projectId,
      warehouseIds: $grid.inParams.warehouseId,
      statusIds: $grid.inParams.statusIds,
      fromDate: $grid.inParams.fromDate,
      toDate: $grid.inParams.toDate,
      dateType: 'CreatedSysDateTime',
      materialIds: $grid.inParams.materialIds,
      fullTextSearch: $grid.fullTextSearch,
      orderIds: orderIds,
      exportLimit: exportLimit,
      reference: $grid.inParams.reference,
      totalRecords: totalRecords,
      exportType: exportType,
      dateFormat: dateFormat
  }
  
  let export_results = (await $flows.SalesOrders.excel_export_flow(inParams))
  
  if ($utils.isDefined(export_results.transactions)) {
  
      transactions = export_results.transactions;
  
      if ($utils.isDefined(export_results.logMessage)) {
          if (export_results.logMessage.length >= 2) {
              await $shell.FootPrintPortalManager.openInfoDialog(export_results.logMessage[0], export_results.logMessage[1]);
          }
      }
  
      var ws = $utils.excel.json_to_sheet(transactions);
      $utils.excel.book_append_sheet(wb, ws, "OutboundOrdersExport");
  
  } else {
      throw new Error("Did not obtain transactions to export from the excel_export_flow!")
  }
  }
  on_print_clicked(event = null) {
    return this.on_print_clickedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_print_clickedInternal(
    $grid: FootPrintPortalManager_shipping_orders_by_tracking_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  const selectedRows = $grid.selectedRows;
  
  for (let selectedRow of selectedRows) {
      let orderId = selectedRow.entity.Id;
      await $reports.SalesOrders.load_slip_report.print({ orderId: orderId });
  }
  
  
  }
  on_grid_data_loaded(event = null) {
    return this.on_grid_data_loadedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_grid_data_loadedInternal(
    $grid: FootPrintPortalManager_shipping_orders_by_tracking_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  const order_data = $grid.rows;
  const outbound_orders = $grid.rows.map(row => row.entity.Id);
  const outbound_shipments = $grid.rows.map(row => row.entity.ShipmentOrderLookups[0]?.ShipmentId)
  
  if (outbound_orders.length > 0) {
  
      const orders = order_data.map(o => {
          return {
              orderId: o.entity.Id,
              orderStatusId: o.entity.OrderStatusId,
              orderStaus: o.entity.Status.Name,
              requestedDeliveryDate: o.entity.RequestedDeliveryDate,
              shipmentId: o.entity.ShipmentOrderLookups[0]?.ShipmentId,
              expectedDate: o.entity.ShipmentOrderLookups[0]?.Shipment.ExpectedDate,
              containerSize: o.entity.ShipmentOrderLookups[0]?.Shipment.ContainerSize,
              shipmentStatusId: o.entity.ShipmentOrderLookups[0]?.Shipment.StatusId,
              waveId: o.entity.ShipmentOrderLookups[0]?.Shipment.WaveId,
              waveStatus: o.entity.ShipmentOrderLookups[0]?.Shipment.Wave?.Status.Name,
              waveStatusId: o.entity.ShipmentOrderLookups[0]?.Shipment.Wave?.StatusId
          }
      });
  
      const order_states = (await $flows.SalesOrders.get_sales_order_state({orders: orders})).states;
  
      const order_addresses = (await $flows.Addresses.get_addresses_single_string_by_orderIds({ orderIds: outbound_orders }));
  
      const address_array = order_addresses.Addresses.map(row => row.OrderId);
      const state_array = order_states.map(row => row.orderId);
  
      for (let row of order_data) {
  
          let picked_total = 0;
          let expected_total = 0;
  
          let orderIndex = -1;
          let orderId = row.entity.Id;
          let orderStatusId = row.entity.OrderStatusId;
  
          let stateId: number = orderStatusId;
          let stateName: string = row.entity.Status.Name;
  
          orderIndex = state_array.indexOf(orderId)
          if (orderIndex > -1) {
              picked_total = order_states[orderIndex].picked_total;
              expected_total = order_states[orderIndex].expected_total;
              stateId = order_states[orderIndex].stateId;
              stateName = order_states[orderIndex].stateName;
          };
  
          //Set the total items
          if (expected_total > 0) {
              if (orderStatusId === 1 && expected_total > 0) {
                  row.cells.total_items.displayControl.text = `${expected_total}`
              } else {
                  row.cells.total_items.displayControl.text = `${picked_total} of ${expected_total}`
              };
          };
  
          row.vars.stateId = stateId;
         
          // Apply ship to
          orderIndex = address_array.indexOf(orderId)
          if (orderIndex >= 0) {
  
              let address = order_addresses.Addresses[orderIndex]
  
              if ($utils.isDefined(address)) {
  
                  let shipTo = '';
  
                  shipTo = address.Address;
  
  
                  if ($utils.isDefined(shipTo)) {
                      if (!shipTo.includes('ord-')) {
                          row.cells.ship_to.displayControl.text = shipTo
  
                      }
                      else {
                          row.cells.ship_to.displayControl.text = '';
    
                      };
                  };
              };
          };
  
      };
  };
  
  }
  on_refresh(event = null) {
    return this.on_refreshInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_refreshInternal(
    $grid: FootPrintPortalManager_shipping_orders_by_tracking_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  $grid.refresh();
  }
  //#endregion private flows


  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_export_flow(wb);

    writeExcelFile(wb, 'FootPrintPortalManager_shipping_orders_by_tracking_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
